import { ReactElement, useEffect } from 'react'
import ImageViewer360 from '@aftermarket-autoparts-alliance/360-images'
import styled from 'styled-components'
import { observer } from 'mobx-react-lite'
import { Spinner } from 'react-bootstrap'
import { ImageFile } from './useImage360'
import { useUserStore } from '../../../../../../src/store/user/UserStore'
import { defaultTheme } from '../../../../../../src/theme'

interface Props {
  images: ImageFile[][]
  loading: boolean
}

enum LanguageKeys {
  EN = 'en',
  ES = 'es',
  FR = 'fr',
}

const LanguageMap = {
  en_US: LanguageKeys.EN,
  es_MX: LanguageKeys.ES,
  fr_CA: LanguageKeys.FR,
}

const image360Theme = {
  primary_btn_color: defaultTheme.colors.primary,
  primary_txt_color: defaultTheme.colors.primaryText,
  secondary_btn_color: defaultTheme.colors.secondary,
  secondary_txt_color: defaultTheme.colors.secondaryText,
}

const Image360View = observer<Props>((props: Props): ReactElement => {
  const { images, loading } = props

  const userStore = useUserStore()

  const languagePreference = userStore.preferences
    .language as keyof typeof LanguageMap
  const language = LanguageMap[languagePreference] as LanguageKeys

  useEffect(() => {
    if (!images?.length) return
    ImageViewer360('img-viewer-container', images, {
      language,
      theme: image360Theme,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Wrapper>
      {loading && (
        <SpinnerWrapper>
          <Spinner />
        </SpinnerWrapper>
      )}
      <Image360Viewer id="img-viewer-container" className="image-viewer-360" />
    </Wrapper>
  )
})

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  position: relative;
  border: 2px solid ${defaultTheme.colors.border};
`

const SpinnerWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
`

const Image360Viewer = styled.div`
  & .image-360-cover {
    z-index: 1;
  }
  & .image-360-controls {
    z-index: 0;
  }
`

export default Image360View
